// extracted by mini-css-extract-plugin
module.exports = {"LEFT_COL":"LeftCol_LEFT_COL__aU9Cl","LEFT_COL__upper":"LeftCol_LEFT_COL__upper__3LsyV","LEFT_COL__lower":"LeftCol_LEFT_COL__lower__21dOn"};